import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PackageSearch, ChevronRight } from "lucide-react";
import { StatusBadge, Spinner, EmptyState } from "../components/common";
import api from "../lib/api";
import { rupiah, fmtDate } from "../lib/format";
import { useI18n } from "../lib/i18n";

export default function Orders() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/orders/mine").then((r) => setOrders(r.data)).finally(() => setLoading(false)); }, []);

  if (loading) return <Spinner />;

  return (
    <div className="space-y-4 max-w-2xl">
      <h1 className="font-heading font-extrabold text-2xl text-navy">{t("nav_orders")}</h1>
      {orders.length === 0 ? (
        <EmptyState icon={PackageSearch} title="Belum ada pesanan" subtitle="Pesanan dari request yang dibayar akan muncul di sini." />
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <button key={o.id} onClick={() => navigate(`/orders/${o.id}`)} data-testid={`order-${o.id}`}
              className="w-full flex items-center gap-3 bg-white rounded-2xl p-4 shadow-soft border border-black/5 text-left hover:bg-cloud transition-colors">
              <div className="w-12 h-12 rounded-xl bg-cloud flex items-center justify-center shrink-0">
                <PackageSearch className="text-navy" size={22} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-heading font-bold text-navy truncate">{o.product_name}</div>
                <div className="text-xs text-muted-foreground">{o.destination} · {fmtDate(o.created_at)}</div>
                <div className="text-sm font-bold text-ink mt-0.5">{rupiah(o.total)}</div>
              </div>
              <div className="flex flex-col items-end gap-2">
                <StatusBadge status={o.status} />
                <ChevronRight size={18} className="text-muted-foreground" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
